import React from "react";

import { WhiteSpace } from "components";
import { makeBEM } from "utils";

import { Flex } from "../../Flex";
import { AppLogo } from "../AppLogo";
import { AppMenu } from "../AppMenu";
import { HelpEmail } from "../HelpEmail";

import "./index.scss";

export interface AppSidebarProps {
  mobile: boolean;
  mobileOpen: boolean;
  onClose: () => void;
  direction?: "rtl" | "ltr";
}

const bem = makeBEM("app-sidebar");

export const AppSidebar: React.FC<AppSidebarProps> = ({ mobile, mobileOpen, onClose, direction }) => {
  return (
    <>
      <nav className={bem(null, [direction], { mobile, open: mobileOpen })}>
        <Flex direction="column" style={{ height: "100%" }} justify="space-between">
          <div>
            <AppLogo />
            <WhiteSpace v="3rem" />
            <AppMenu />
          </div>
          <div>
            <HelpEmail />
          </div>
        </Flex>
      </nav>
      <div className={bem("overlay", { visible: mobile && mobileOpen })} onClick={onClose} />
    </>
  );
};
